module.exports = __webpack_public_path__ + "static/media/mode.9947a074.svg";